export async function paginate (api, baseUrl, limit, offset, callback = null, options = {}) {
  const data = []
  const generator = getPaginated(api, baseUrl, limit, offset, options)
  for await (const result of generator) {
    if (callback) {
      const results = await Promise.allSettled(result.map(r => callback(r)))
      data.push(...results)
    } else {
      data.push(...result)
    }
  }
  return { data }
}

async function* getPaginated (api, baseUrl, limit, offset, options = {}) {
  const {
    check_allowances = false,
    item_id_filter = null,
    upc_filter = null,
    description_filter = null,
    source_filter = null,
    item_group_name_filter = null,
    vendor_filter = null,
    dataKey = null
  } = options
  let page = 1

  while (true) {
    if (page > 1) {
      offset = (page * limit) - limit
    }
    const res = await api({
      url: baseUrl,
      method: 'GET',
      params: { limit, offset, check_allowances, item_id_filter, upc_filter, description_filter, source_filter, item_group_name_filter, vendor_filter }
    })
    // Some endpoints wrap the page in an envelope (e.g. { items, total_count });
    // callers pass dataKey to pull the array out. Others return the array directly.
    const items = dataKey ? res.data?.[dataKey] : res.data
    if (!items || items.length === 0) {
      break
    }

    yield items

    if (items.length < limit) break
    page++
  }
}
